import {Column, Row} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {store} from "../../../../Store/index.js";
import {Session} from "../../../../Server/DB/sessions/@Session.js";
import {DetailChart} from "./DetailsUI/DetailChart.js";
import {InDesktop} from "../../../../Utils/Bridge/Bridge_Native.js";
import {ES} from "web-vcore";
import {Observer, useForceUpdate} from "web-vcore";
import {DetailPanelSettingsUI} from "./DetailsUI/DetailPanelSettingsUI.js";
import {VideoRecordingPlayer} from "./DetailsUI/VideoRecordingPlayer.js";
import {SeekBar} from "./SeekBar.js";
import {SessionUI_SharedProps} from "../SessionUI.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";
import {GetSelectedSessionExternals} from "../../../../Store/main/timeline/SessionDerivativeData.js";
import {GetSessionProcessors} from "../../../@Shared/Processors/@ProcessorInstances.js";
import {GetSessionSubpath} from "../../../../Server/DB/sessions.js";

export const SessionUI_DetailsUI = observer_mgl((props: SessionUI_SharedProps)=>{
	const {session} = props;
	const uiState = store.main.timeline.sessions;
	return (
		<Column style={{flex: 1}}>
			<DetailsPanel session={session}/>
			{uiState.seekBar_show && <SeekBar session={session}/>}
		</Column>
	);
});

export const DetailsPanel = observer_mgl((props: {session: Session})=>{
	const {session} = props;
	const forceUpdate = useForceUpdate();

	if (!g.t1) debugger;
	const uiState = store.main.timeline.sessions;
	const processor = GetSessionProcessors().Active;
	if (processor?.eegProcessor?.options == null) return (setTimeout(()=>forceUpdate(), 100), null); // wait 100ms, then retry
	//if (!InDesktop()) return <Row m={10} style={ES({flex: 1})}>Detail-panel only usable in the desktop app. (raw eeg data not available elsewhere)</Row>;
	const sessionExt = GetSelectedSessionExternals();
	if (sessionExt == null) return null;
	//if (detailPanelEEGProcessor.options == null) return null; // wait
	//if (detailPanelEEGProcessor_reflector?.options == null) return null; // wait
	if (processor.loadedSessionData?.session != session) return (setTimeout(()=>forceUpdate(), 100), null); // wait 100ms, then retry

	/*if ((processor.loadedSessionData?.eegSampleFiles.left.samplesBySecond.VKeys().length ?? 0) == 0) {
		return <Row m={10} style={ES({flex: 1})}>Files containing raw eeg data for session not found. (or still loading)</Row>;
	}
	if ((processor.loadedSessionData?.gyroSampleFiles.x.samplesBySecond.VKeys().length ?? 0) == 0) {
		return <Row m={10} style={ES({flex: 1})}>Files containing raw gyro data for session not found. (or still loading)</Row>;
	}
	console.log("TestA");*/

	const camRecordingPeriods_final = sessionExt.CamRecordingPeriods_Adjusted(uiState.videoLatency);
	const lastRecordingForTime_period = camRecordingPeriods_final.filter(a=>a.end > uiState.currentTime && a.start <= uiState.currentTime).LastOrX();
	if (lastRecordingForTime_period) {
		var lastRecordingForTime_filename = sessionExt.generalHistory.camFilenames[camRecordingPeriods_final.indexOf(lastRecordingForTime_period)];
		var lastRecordingForTime_path = GetSessionSubpath(session!._folderName!, `Camera/${lastRecordingForTime_filename}`);
	}

	return (
		<Row mt={10} style={ES({flex: 1})}>
			<Column style={ES({flex: 1, position: "relative"})}>
				{lastRecordingForTime_path! && uiState.video_show &&
					<VideoRecordingPlayer session={session} period={lastRecordingForTime_period!} path={lastRecordingForTime_path}/>}
				<DetailChart processor={processor} session={session}
					//startTime={visibleRange_firstSecond} endTime={visibleRange_endSecond}
					initialViewRange={uiState.initialViewRange * 1000}
					maxViewRange={uiState.maxViewRange * 1000}
					//startSample={visibleRange_startSampleIndex} endSample={visibleRange_endSampleIndex} processedExtent={detailPanelEEGProcessor.processedExtentFromCenter}
				/>
			</Column>
			<DetailPanelSettingsUI session={session}/>
		</Row>
	);
});